import React, { useEffect, useRef, forwardRef, useImperativeHandle, useState } from 'react';
import CBToast from '@cb/apricot/CBToast';
import cn from 'classnames';
import { useUID } from 'react-uid';
export const toastType = ['alternative', 'success', 'warning', 'info'];
export const iconType = ['check-fill', 'exclamation-fill', 'info-circle'];
export const Toasts = ({ children, bottom = false, offsetTop = 0, offsetBottom = 16 }) => {
    const [childrenList, setChildren] = useState([]);
    useEffect(() => {
        // Reverse the order for toast effect
        setChildren(React.Children.toArray(children).reverse());
    }, [children]);
    return (React.createElement("div", { className: cn('cb-toast-container', bottom && 'cb-toast-container-bottom'), style: {
            top: !bottom ? offsetTop : 0,
            bottom: bottom ? offsetBottom : 'auto',
        } }, childrenList));
};
export const Toast = forwardRef(({ toastId, controlled = false, show = false, timeout = 5000, type, icon, className, message, ctaLabel, ctaAriaLabel, ctaCallback = null, closeBtn = true, closeAriaLabel = 'Close alert', onDismiss = null, autoClose = true, escClose = true, }, ref) => {
    const iconMsg = type === 'success' || type === 'warning' || type === 'info' ? type : null;
    const toastClass = cn('cb-toast', type && `cb-toast-${type}`, className);
    const refToast = useRef(null);
    const uid = useUID();
    // eslint-disable-next-line no-param-reassign
    toastId = toastId || `apricot_toast_${uid}`;
    const messageId = `apricot_msgToast_${uid}`;
    const [showToast, setDisplayState] = useState(true);
    useImperativeHandle(ref, () => refToast.current);
    // toast instance
    const toast = useRef(null);
    const removeToast = (event) => {
        const elem = event ? event.data.elem : null;
        if (elem && elem === refToast.current) {
            if (controlled) {
                // eslint-disable-next-line no-param-reassign
                show = false;
            }
            else {
                setDisplayState(false);
            }
        }
    };
    // general treatment
    useEffect(() => {
        if (!controlled) {
            toast.current = CBToast({
                elem: refToast.current,
                timeout,
                ctaCallback,
                onDismiss,
                escClose,
                autoClose,
                react: true,
            });
        }
    }, []);
    // controlled
    useEffect(() => {
        if (controlled) {
            if (show) {
                toast.current = CBToast({
                    elem: refToast.current,
                    timeout,
                    ctaCallback,
                    onDismiss,
                    escClose: false,
                    autoClose: false,
                    react: true,
                    controlled,
                });
            }
            else {
                // clean up
                toast.current && toast.current.hide();
            }
        }
    }, [show]);
    // remove Instance
    const isCalledRef = useRef(false);
    useEffect(() => {
        document.addEventListener('apricot_toast_hide', removeToast);
        return () => {
            // We just want this to run once
            if (toast.current && isCalledRef.current) {
                toast.current.destroy();
            }
            else if (toast.current) {
                isCalledRef.current = true;
            }
        };
    }, []);
    return (!controlled && showToast) || (controlled && show) ? (React.createElement("div", { role: ctaLabel ? 'alertdialog' : 'alert', className: toastClass, ref: refToast, "aria-hidden": true, id: toastId, "aria-describedby": ctaLabel ? messageId : undefined, "data-cbtrack-comp": "apricot-react:toast" },
        icon && (React.createElement("span", { className: `cb-icon cb-${icon} cb-margin-right-8`, "aria-hidden": !iconMsg ? true : undefined },
            React.createElement("span", { className: "sr-only" }, iconMsg))),
        typeof message === 'string' ? (React.createElement("p", { className: "cb-toast-msg", id: messageId }, message)) : (React.createElement("div", { className: "cb-toast-msg", id: messageId }, message)),
        ctaLabel && (React.createElement("a", { href: "/#", className: "cb-toast-action cb-margin-left-16", "aria-label": ctaAriaLabel }, ctaLabel)),
        closeBtn && (React.createElement("button", { type: "button", className: "cb-btn cb-btn-square cb-btn-greyscale cb-btn-close cb-margin-left-8" },
            React.createElement("span", { className: "cb-icon cb-x-mark", "aria-hidden": "true" }),
            React.createElement("span", { className: "sr-only" }, closeAriaLabel))))) : null;
});
//# sourceMappingURL=Toasts.js.map